var readMoreBlocks = document.querySelectorAll('.js-mobile-readmore');

readMoreBlocks.forEach(function (block) {
    var textContainer = block.querySelector('.js-mobile-readmore-text');
    var toggle = block.querySelector('.js-mobile-readmore-toggle');
    var wordLimit = parseInt(block.getAttribute('data-word-limit'), 10) || 10;

    if (!textContainer || !toggle) return;

    var moreLabel = toggle.getAttribute('data-label-more') || 'Read more';
    var lessLabel = toggle.getAttribute('data-label-less') || 'Read less';

    var fullHtml = textContainer.innerHTML.trim();
    var temp = document.createElement('div');
    temp.innerHTML = fullHtml;

    var fullText = (temp.textContent || temp.innerText || '').trim();
    var words = fullText.split(/\s+/).filter(Boolean);

    if (words.length <= wordLimit) {
        toggle.remove();
        return;
    }

    var excerpt = words.slice(0, wordLimit).join(' ') + '...';

    textContainer.setAttribute('data-full-html', fullHtml);
    textContainer.setAttribute('data-excerpt', excerpt);
    textContainer.textContent = excerpt;

    toggle.textContent = moreLabel;
    toggle.style.display = 'inline-block';

    toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
            textContainer.textContent = textContainer.getAttribute('data-excerpt');
            toggle.textContent = moreLabel;
            toggle.setAttribute('aria-expanded', 'false');
        } else {
            textContainer.innerHTML = textContainer.getAttribute('data-full-html');
            toggle.textContent = lessLabel;
            toggle.setAttribute('aria-expanded', 'true');
        }
    });
});


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/excerpt.js